import React from "react";
import { PageLayout } from "../components/page-layout";
import {LeaderboardGraph} from "../components/statistics/leaderboard-graph";

export const StatisticsPage = () => {
  return (
    <PageLayout>
      <div className="content-layout">
        <div className="content__body">
          <LeaderboardGraph />
        </div>
      </div>
    </PageLayout>
  );
};